/**
 * `DEV001` / 숫자 문자열 → PUT·DELETE `/device/{organizationDeviceId}` 용 id
 */
export function parseUiDeviceIdToApiOrganizationDeviceId(id: string): number | null {
	const t = id.trim();
	if (!t) return null;
	if (/^\d+$/.test(t)) {
		const n = parseInt(t, 10);
		if (Number.isFinite(n) && n > 0) return n;
		return null;
	}
	const digits = t.replace(/\D/g, '');
	if (!digits) return null;
	const n = parseInt(digits, 10);
	if (!Number.isFinite(n) || n <= 0) return null;
	return n;
}
